import { ComponentType } from 'react';

import CreateNewRoomDataProvider, { CreateNewRoomDataProviderProps } from './CreateNewRoomDataProvider';

const withCreateNewRoomDataProvider = <P extends object>(Component: ComponentType<P>) => {
  const WithCreateNewRoomDataProvider: React.FC<P & CreateNewRoomDataProviderProps> = ({
    isScheduledInitially,
    isPrivateInitially,
    room,
    ...props
  }) => (
    <CreateNewRoomDataProvider
      isScheduledInitially={isScheduledInitially}
      isPrivateInitially={isPrivateInitially}
      room={room}
    >
      <Component {...(props as P)} />
    </CreateNewRoomDataProvider>
  );

  return WithCreateNewRoomDataProvider;
};

export default withCreateNewRoomDataProvider;
